import axios from 'axios';

const url = 'https://apidir.pfdo.ru/v1';

export const fetchFaqTemplates = (params) => axios.get(url, { params });

export const fetchFaqTemplate = (id, params) => axios.get(`${url}/${id}`, { params });

export default {

  getServiceHelps(params) {
    return axios.get(`${url}/service-helps`, { params });
  },

  showServiceHelp(id, params) {
    return axios.get(`${url}/service-helps/${id}`, { params });
  },

  getHelps(params) {
    return axios.get(`${url}/helps`, { params });
  },

  showHelp(id, params) {
    return axios.get(`${url}/helps/${id}`, { params: { expand: 'body', ...params } });
  },

};
